/* 🤖 this file was generated by script */
export const wiconHash02 = {
  name: 'hash_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.5 3l-3 18m11-18l-3 18m6-13h-17m16 8h-17"/></svg>`,
};
